import { Loading } from '@livecontrol/core-ui';
import { useEffect } from 'react';
import type { ReactElement } from 'react';
import { Redirect } from 'react-router-dom';
import { Store } from '../store';

export const Logout = (): ReactElement => {
  const token = Store.Token.useToken();

  useEffect(() => {
    Store.User.logout();
  }, []);

  return token ? <Loading.Delay /> : <Redirect to='/home' />;
};
